export const DealerNavSections = {
  INFORMATION: 'information',
  USERS: 'users',
  VEHICLES: 'vehicles',
  BIDS: 'bids',
  TRANSACTIONS: 'transactions',
  INVOICES: 'invoices',
  BLACKLIST: 'blacklist',
};
